module.exports = __webpack_public_path__ + "static/img/tiggy_pictgrid37_1040x861.2e75637.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/tiggy_pictgrid37_1040x861.jpg
// module id = Ok3V
// module chunks = 0